module.exports = __webpack_public_path__ + "img/fig23.c74825e4.jpg";